import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m9.357 13.42-.002-.004L21.698 1.08h.009l.08-.08H18.96l-2.266 2.27A5.002 5.002 0 0 0 7 5v7c0 .308.028.61.081.903l-1.613 1.618A6.983 6.983 0 0 1 5 12v-1H3v1c0 1.452.344 2.823.954 4.037L0 20l2.772-.01 2.276-2.273.006.007L6.477 16.3l-.005-.006 1.43-1.429.004.006 1.451-1.451ZM9 10.98l6-6.012A3 3 0 0 0 9 5v5.98Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m10.84 14.767-1.48 1.48A5 5 0 0 0 17 12V8.606l-2 2V12a3 3 0 0 1-4.16 2.767Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m7.919 17.688-1.43 1.428A9 9 0 0 0 21 12v-1h-1.999v1A7 7 0 0 1 7.92 17.688ZM9 22v2h6v-2H9Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconActionMute24 = createIcon(IconComponent);